<template lang="pug">
  .flow-builder-validate-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="platform in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 Validar variables
        p.text-secondary.text-sm Te permite comparar valores y ejecuta un conector si se cumple la condición especificada.
        p.text-help.text-sm Para que el conector de los elementos se ejecuten se deben cumplir todas las condiciones. En caso contrario, se ejecuta el conector fallido.
      validate-element(v-for="element in Elements", :key="element.element_id", v-if="element.type === 'validation'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", :validation-types="validationTypes", @destroy="destroyTemplateElement(element)")
      add-element-button.mb-3(@click="createTemplateElement", v-if="!disabled", title="Agregar comparación")
      template-connector(v-for="connector in Template_Connectors", :key="connector.template_connector_id", v-bind="connector", :block_id="block_id", :disabled="disabled")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import templateCommon from '@/helpers/template-common'
import ValidateElement from '@/components/templates/ValidateElement.vue'
import Connector from '@/components/templates/connectors/Connector.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import AddElementButton from '@/components/AddElementButton.vue'

const accountController = createNamespacedHelpers('account')

export default {
  mixins: [templateCommon],
  data () {
    return {
      validationTypes: [
        {
          label: '=',
          id: 'equal'
        },
        {
          label: '!=',
          id: 'not_equal'
        },
        {
          label: '<',
          id: 'less_than'
        },
        {
          label: '<=',
          id: 'less_than_or_equal_to'
        },
        {
          label: '>',
          id: 'greater_than'
        },
        {
          label: '>=',
          id: 'greater_than_or_equal_to'
        },
        { label: 'Ω', id: 'matcher' }
      ]
    }
  },
  components: {
    ValidateElement,
    'template-connector': Connector,
    TemplateTools,
    AddElementButton
  },
  created () {
    this.createTemplateElement = () => {
      let self = this
      let element = {
        type: 'validation',
        number: self.Elements.length + 1,
        attributes: [
          {
            name: 'comparisons',
            value: '[]'
          }
        ],
        connectors: [
          {
            type: 'compare_success'
          }
        ]
      }

      this.createElement(this.block_id, this.template_id, element)
    }

    this.destroyTemplateElement = (element) => {
      this.destroyElement(this.block_id, this.template_id, element)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-validate-template {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
